import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = (props: SvgProps) => (
    <Svg width={24} height={24} viewBox="0 0 24 24" {...props} fill="none">
        <Path
            d="M8.03334 12.1996L10.6333 14.7996L15.7667 9.66628M20.4 11.9996C20.4 16.6388 16.6392 20.3996 12 20.3996C7.36081 20.3996 3.60001 16.6388 3.60001 11.9996C3.60001 7.36042 7.36081 3.59961 12 3.59961C16.6392 3.59961 20.4 7.36042 20.4 11.9996Z"
            stroke={props.fill ?? designSystem.colors.neutral300}
            strokeWidth={1.75}
            strokeLinejoin="round"
        />
    </Svg>
);
export { SvgComponent as CheckmarkOutlinedIcon };
